"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PageEnConstruction} from "@/components/common/page-en-construction";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

              <EspaceProTitleCard title={"Quelques Outils de Bonne Gouvernance"}
                                  middleBreadcrumbs={[{title: "Devenir Partenaire", link: "/espace-pro/devenir-partenaire"}]}
                                  description={"Participer à la création d’une industrie touristique durable."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <PageEnConstruction />
          </SectionPage>

        </div>
  );
}
